<template>
  <v-container class="mt-0">
      <v-layout row wrap justify-center v-if="loading">
        <v-flex xs12 sm8 md6 class="text-xs-center">
          <v-progress-circular 
          indeterminate 
          color="primary"
          :width="7"
          :size="70"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    <v-layout row v-else>
      <v-flex xs12 sm6 offset-sm3 class="text-xs-center">
        <h1 class="mt-3 text-xs-center">{{ investigator.investigatorName }}</h1>
				<v-card>
					<v-card-text>
						Phone Number: {{ investigator.investigatorPhone }}
					</v-card-text>
					<v-card-text>
						Email Address: {{ investigator.investigatorEmail }}
					</v-card-text>
				</v-card>
        <v-divider></v-divider>
				<template v-if="userIsCreator">
					<v-spacer></v-spacer>
					<app-edit-investigator-dialog :investigator="investigator"></app-edit-investigator-dialog>
				</template>
        <v-btn dark flat class="red darken-3" @click="onDeleteInvestigator(investigator)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
      </v-flex>
    </v-layout>
		
  </v-container>
</template>

<script>
export default {
  data () {
    return {
    //  dialog: false
    }
  },
  props: ['id'],
  methods: {
    onDeleteInvestigator (investigator) {
      console.log('Delete this: ' + JSON.stringify(investigator))
      this.$store.dispatch('deleteInvestigatorData', investigator)
      this.$router.push('/investigators')
    }
  },
  computed: {
    investigator () {
      return this.$store.getters.loadedInvestigator(this.id)
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator () {
      if (!this.userIsAuthenticated) {
        return false
      }
      return this.$store.getters.user.id === this.investigator.creatorId
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>


// WEBPACK FOOTER //
// Investigator.vue?6cb7ed28